export const DS_MAX_DISPLAYED_AVATARS = 6;
// Equals to the Design token `ds-gap-negative-s`
export const DS_AVATAR_OFFSET = -8;
export const AVATAR_SIZE = {
    MEDIUM: 'medium',
    SMALL: 'small',
};
export const AVATAR_SHAPE = {
    CIRCLE: 'circle',
    SQUARE: 'square',
};
export const AVATAR_COLORS_COUNT = 18;
